<template>
  <div class="legend-immokey">
    <h3 class="legend-lable">
      {{ lang == 'CN' ? '符号说明' : 'Description' }}
    </h3>
    <div class="legend-wrap">
      <legend-item
        v-for="(item, index) in immoSupport"
        :key="index"
        :icon="item.icon"
        :desc="item[lang.toLowerCase()]"
      ></legend-item>
    </div>
  </div>
</template>
<script>
export default {
  name: 'legend-immokey',
  props: {
    lang: {
      type: String,
      default() {
        return this.$getLang()
      },
    },
  },
  computed: {
    immoSupport() {
      return this.$store.state.immoSupport
    },
  },
}
</script>
<style lang="less">
.legend-immokey {
  padding-bottom: 15px;
  .legend-lable {
    margin-top: 0;
    margin-bottom: 2px;
  }
  .legend-wrap {
    display: flex;
    flex-wrap: wrap;
    .legend-item {
      width: 33%;
    }
  }
}
</style>